/* ================================================================
   Header.jsx
================================================================ */

import { useState, useEffect } from "react";
import { FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";
import Logo from "../../Comon/Images/GarvanaIcon.png";
import NavigationBar from "../NavigationBar/NavigationBar";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const closeOnResize = () => {
      if (window.innerWidth >= 1024) setMenuOpen(false);
    };
    window.addEventListener("resize", closeOnResize);
    return () => window.removeEventListener("resize", closeOnResize);
  }, []);

  return (
    <>
      <header className={`header ${scrolled ? "header--scrolled" : ""}`}>

        {/* LOGO — Icon + Text + Tagline */}
        <Link to="/" className="header__logo">
          <img
            src={Logo}
            alt="Garvaana Enterprise"
            className={`header__logo-img ${scrolled ? "header__logo-img--scrolled" : ""}`}
          />
          <div className="header__logo-text">
            <span className="header__logo-name">Garvaana</span>

            {/* Animated Enterprise row */}
            <div className="header__logo-tagline-row">
              <span className="tagline-dot" />
              <span className="tagline-line" />
              <span className="header__logo-sub">Enterprise</span>
              <span className="tagline-line" />
              <span className="tagline-dot" />
            </div>
          </div>
        </Link>

        {/* NAV */}
        <NavigationBar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        {/* CTA */}
        <a href="tel:+919800040505" className="header__cta">
          Book Free Consultation
        </a>

        {/* HAMBURGER */}
        <button
          className="header__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <FiMenu size={22} />
        </button>

      </header>

      {menuOpen && (
        <div className="header__overlay" onClick={() => setMenuOpen(false)} />
      )}
    </>
  );
}